import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
// 以下5ページはÉCLATテンプレート由来の英語ページ。トップページ以外は使用しないため入口を無効化（ファイルは残す。復活時はコメントを解除するだけ）
// import CollectionsPage from "../pages/collections/page";
// import ProcessPage from "../pages/process/page";
// import ShowcasePage from "../pages/showcase/page";
// import VoicesPage from "../pages/voices/page";
// import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // 以下5ページはÉCLATテンプレート由来の英語ページ。トップページ以外は使用しないため入口を無効化（ファイルは残す。復活時はコメントを解除するだけ）
  // {
  //   path: "/collections",
  //   element: <CollectionsPage />,
  // },
  // {
  //   path: "/process",
  //   element: <ProcessPage />,
  // },
  // {
  //   path: "/showcase",
  //   element: <ShowcasePage />,
  // },
  // {
  //   path: "/voices",
  //   element: <VoicesPage />,
  // },
  // {
  //   path: "/contact",
  //   element: <ContactPage />,
  // },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;